export default "__VITE_ASSET__CZKR3W6b__"